import React from "react";
import { Grid } from "@mui/material";
import { ElectricBolt as PowerIcon } from "@mui/icons-material";
import type { VenueData } from "../../types/venues.types";

interface PowerInfoCardProps {
  venueData: VenueData;
  InfoCard: React.ComponentType<{
    title: string;
    icon: React.ReactNode;
    sx?: object;
    children: React.ReactNode;
  }>;
  InfoRow: React.ComponentType<{
    label: string;
    value: string;
  }>;
}

export const PowerInfoCard: React.FC<PowerInfoCardProps> = ({
  venueData,
  InfoCard,
  InfoRow,
}) => {
  return (
    <InfoCard title="Power" icon={<PowerIcon />} sx={{ height: "100%" }}>
      <Grid container spacing={2}>
        <InfoRow label="Has Power" value={venueData.has_power ? "Yes" : "No"} />
        <InfoRow label="Power Type" value={venueData.power_type || "N/A"} />
        <InfoRow
          label="Power Outage Rate"
          value={venueData.power_outage_rate || "N/A"}
        />
        <InfoRow
          label="Power Socket Type"
          value={venueData.power_socket_type || "N/A"}
        />
        <InfoRow label="Power Backup" value={venueData.power_backup || "N/A"} />
        <InfoRow
          label="Backup Power Capacity"
          value={venueData.backup_power_capacity || "N/A"}
        />
        <InfoRow
          label="Distance from Livestream Desk"
          value={venueData.power_distance_from_livestream_desk || "N/A"}
        />
      </Grid>
    </InfoCard>
  );
};

export default PowerInfoCard;
